export const filterConfigText = (value) => {
  if (
    Object.keys(configTranslations).filter((item) => item == value).length == 0
  ) {
    return {};
  }

  return {
    text: `${headerTypes[configTranslations[value].type]} ${
      configTranslations[value].isButton ? "Botão" : ""
    }
    ${configTranslations[value].name}`,
    description: configTranslations[value].description,
  };
};

const configTranslations = {
  acompanhamentos: {
    name: "Acompanhamentos",
    type: "cidade",
    description: [`Visualiza a aba 'Acompanhamentos' dentro do município`],
  },
  agenteTerritorial: {
    isButton: true,
    name: "Agente Territorial",
    type: "cidade",
    description: [`Visualiza o botão 'AGENTE TERRITORIAL' dentro do município`],
  },
  analisarAprovadas: {
    isButton: true,
    name: "Analisar Aprovadas",
    type: "evidencia",
    description: [
      `Pode aprovar evidências dentro da aba 'Evidências -> Evidenciadas' no município`,
    ],
  },
  analisarEvidenciadas: {
    isButton: true,
    name: "Analisar Evidenciadas",
    type: "evidencia",
    description: [
      `Pode finalizar evidências do selo dentro da aba 'Evidências' no município`,
    ],
  },
  analisarRejeitadas: {
    isButton: true,
    name: "Analisar Rejeitadas",
    type: "evidencia",
    description: [
      `Pode rejeitar evidências dentro da aba 'Evidências' no município`,
    ],
  },
  analisarRelatorios: {
    name: "Analisar Relatorios",
    type: "menu",
    description: [
      `Libera visualização do menu (meus relatórios/analisar relatórios), porém cada um possui sua permissão separadamente`,
    ],
  },
  analisarRelatoriosAdministrativos: {
    name: "Analisar Relatorios Administrativos",
    type: "menu",
    description: [
      `Libera visualização do menu (Analisar Relatórios Administrativos/Meus Relatórios Administrativos)`,
    ],
  },
  andamento: {
    name: "Andamento",
    type: "cidade",
    description: [`Libera visualização da aba 'Andamento' dentro do município`],
  },
  cadastroEmLote: {
    isButton: true,
    name: "Cadastro em Lote",
    type: "cidade",
    description: [
      `Libera o botão 'Cadastrar em lote' dentro do filtro na listagem de município`,
    ],
  },
  calendario: {
    name: "Calendário",
    type: "cidade",
    description: [
      `Libera a visualização da aba 'Calendário' dentro do município`,
    ],
  },
  configuracao: {
    name: "Configuração",
    type: "menu",
    description: [`Libera a visualização do menu 'Configuração'`],
  },
  dashboardAdministrativo: {
    name: "Dashboard Administrativo",
    type: "menu",
    description: [`Libera a visualização do menu 'Dashboard'`],
  },
  editarMunicipio: {
    isButton: true,
    name: "Editar Município",
    type: "cidade",
    description: [`Libera o botão 'Editar Município' dentro do município`],
  },
  eixos: {
    name: "Eixos",
    type: "menu",
    description: [`Libera a visualização do menu 'Eixos'`],
  },
  encontros: {
    name: "Encontros",
    type: "menu",
    description: [`Libera a visualização do menu 'Agendas/Encontros'`],
  },
  enviarAprovadas: {
    isButton: true,
    name: "Enviar Aprovadas",
    type: "evidencia",
    description: [
      `Libera a possibilidade de enviar arquivos na aba de aprovadas em evidências que não seja selo`,
    ],
  },
  enviarEvidenciadas: {
    isButton: true,
    name: "Enviar Evidenciadas",
    type: "evidencia",
    description: [
      `Libera a possibilidade de enviar arquivos na aba de evidenciadas em evidências que não seja selo`,
    ],
  },
  enviarRejeitadas: {
    isButton: true,
    name: "Enviar Rejeitadas",
    type: "evidencia",
    description: [
      `Libera a possibilidade de enviar arquivos na aba de rejeitadas em evidências`,
      `Libera os botões 'Salvar e enviar' no selo`,
    ],
  },
  enviarRespondidas: {
    isButton: true,
    name: "Enviar Respondidas",
    type: "evidencia",
    description: [
      `Libera a possibilidade de enviar arquivos na aba de respondidas em evidências`,
      `Libera os botões 'Salvar e enviar' no selo`,
    ],
  },
  eventos: {
    name: "Eventos",
    type: "menu",
    description: [`Libera a visualização do menu 'Eventos'`],
  },
  evidencias: {
    name: "Evidências",
    type: "cidade",
    description: [
      `Libera a visualização da aba 'Evidências' dentro do município`,
    ],
  },
  finalizarAcompanhamento: {
    isButton: true,
    name: "Finalizar Acompanhamento",
    type: "cidade",
    description: [
      `Libera a visualização do botão 'Finalizar' dentro de Cidade -> Acompanhamento -> Escolha o acompanhamento`,
    ],
  },
  grupo: {
    name: "Grupos",
    type: "menu",
    description: [`Libera a visualização do menu 'Grupos'`],
  },
  grupos: {
    name: "Grupos",
    type: "cidade",
    description: [`Libera a visualização da aba 'Grupos' dentro do município`],
  },
  medalhas: {
    name: "Medalhas",
    type: "menu",
    description: [`Libera a visualização do menu 'Medalhas'`],
  },
  meusProcessosPagamentos: {
    name: "Meus Processos de Pagamentos",
    type: "menu",
    description: [
      `Libera a visualização do menu 'Meus Processos de Pagamentos'`,
    ],
  },
  novoAcompanhamento: {
    isButton: true,
    name: "Novo Acompanhamento",
    type: "cidade",
    description: [
      `Libera a visualização do botão 'Novo Acompanhamento' dentro de Cidade -> Acompanhamento`,
    ],
  },
  novoEvento: {
    isButton: true,
    name: "Novo Evento",
    type: "calendario",
    description: [
      `Libera a visualização do botão 'novoEvento' dentro de Cidade -> Calendário`,
    ],
  },
  novoGrupo: {
    isButton: true,
    name: "Novo Grupo",
    type: "grupo",
    description: [
      `Libera a visualização do botão '+ Grupo' dentro de Cidade -> Grupos`,
    ],
  },
  novoRelatorio: {
    isButton: true,
    name: "Novo Relatório",
    type: "relatorio",
    description: [
      `Libera a visualização do botão 'Novo Relatório' dentro de Cidade -> Relatórios`,
    ],
  },
  novoRelatorioAdministrativo: {
    isButton: true,
    name: "Novo Relatório Admin.",
    type: "relatorioAdmin",
    description: [
      `Libera a visualização do botão 'Novo Relatório Administrativo' dentro de Cidade -> Relatório Administrativo`,
    ],
  },
  pacotes: {
    name: "Pacotes",
    type: "menu",
    description: [`Libera a visualização do menu 'Pacotes'`],
  },
  perguntas: {
    name: "Perguntas",
    type: "menu",
    description: [`Libera a visualização do menu 'Perguntas'`],
  },
  processosPagamento: {
    name: "Processos de Pagamento",
    type: "menu",
    description: [`Libera a visualização do menu 'Processos de Pagamento'`],
  },
  projetoseSolucoes: {
    name: "Projetos e Soluções",
    type: "menu",
    description: [`Libera a visualização do menu 'Projetos e Soluções'`],
  },
  realizarDiagnostico: {
    name: "Realizar Diagnóstico",
    type: "cidade",
    description: [
      `Libera a visualização do botão 'RESPONDER CRITÉRIOS DE AVALIAÇÃO/RESPONDER DIAGNÓSTICO' dentro do município, caso o diagnóstico não tenha sido respondido ainda.`,
    ],
  },
  relatorioAdministrativo: {
    name: "Relatório Administrativo",
    type: "cidade",
    description: [
      `Libera a visualização da aba 'Relatório Administrativo' dentro do município`,
      `Libera a visualização da opção 'Incluir Relatórios Administrativos' dentro do Relatório Global`,
    ],
  },
  relatorioGlobal: {
    isButton: true,
    name: "Relatório Global",
    type: "dashboard",
    description: [
      `Libera a visualização do botão 'Relatório Global' dentro do menu Dashboard`,
    ],
  },
  relatorioMensal: {
    isButton: true,
    name: "Relatório Mensal",
    type: "cidade",
    description: [
      `Libera a visualização do botão 'Relatório Mensal' dentro do município`,
    ],
  },
  relatorios: {
    name: "Relatórios",
    type: "cidade",
    description: [
      `Libera a visualização da aba 'Relatório' dentro do município`,
    ],
  },
  resumoMunicipio: {
    isButton: true,
    name: "Atores do Município",
    type: "cidade",
    description: [
      `Libera a visualização do botão 'RESUMO DO PARCEIRO/Municipio | Atores do município' dentro do município`,
    ],
  },
  sala: {
    name: "Sala",
    type: "cidade",
    description: [`Libera a visualização da aba 'Sala' dentro do município`],
  },
  salaEmpreendedor: {
    name: "Sala do Empreendedor",
    type: "menu",
    description: [`Libera a visualização do menu 'Sala do Empreendedor'`],
  },
  salvarMunicipio: {
    isButton: true,
    name: "Editar Municipio --> Salvar",
    type: "cidade",
    description: [
      `Libera a visualização do botão 'Salvar' municipios não vigentes dentro da edição de município`,
    ],
  },
  salvarMunicipioVigente: {
    isButton: true,
    name: "Editar Municipio --> Salvar (Municipios Vigente)",
    type: "cidade",
    description: [
      `Libera a visualização do botão 'Salvar' municipios vigentes dentro da edição de município`,
    ],
  },
  temas: {
    name: "Temas",
    type: "menu",
    description: [`Libera a visualização do menu 'Temas'`],
  },
  termoReferencia: {
    name: "Termo de Referência",
    type: "cidade",
    description: [
      `Libera a visualização da aba 'Termos de Referência' dentro do município`,
    ],
  },
  unidadesRegionais: {
    name: "Unidades Regionais",
    type: "menu",
    description: [`Libera a visualização do menu 'Unidades Regionais'`],
  },
  usuarios: {
    name: "Usuarios",
    type: "menu",
    description: [`Libera a visualização do menu 'Usuarios'`],
  },
  visualizarAprovadas: {
    isButton: true,
    name: "Visualizar Aprovadas",
    type: "evidencia",
    description: [
      `Libera a visualização dos arquivos na tela de Aprovadas em Cidade -> Evidências`,
    ],
  },
  visualizarEvidenciadas: {
    isButton: true,
    name: "Visualizar Evidenciadas",
    type: "evidencia",
    description: [
      `Libera a visualização dos arquivos na tela de Evidenciadas em Cidade -> Evidências`,
    ],
  },
  visualizarLogo: {
    name: "Visualizar Logo no Sistema",
    type: "sistema",
    description: [
      `Libera a visualização da logo do sistema em páginas e relatórios`,
    ],
  },
  visualizarPontosMedalha: {
    name: "Visualizar Pontos e Medalhas",
    type: "sistema",
    description: [`Libera a visualização dos pontos e medalhas do sistema`],
  },
  visualizarRejeitadas: {
    isButton: true,
    name: "Visualizar Rejeitadas",
    type: "evidencia",
    description: [
      `Libera a visualização dos arquivos na tela de Rejeitadas em Cidade -> Evidências`,
    ],
  },
  desabilitarUsuario: {
    isButton: true,
    name: "Desabilitar e habilitar usuário",
    type: "usuario",
    description: [
      `Libera a visualização do botão 'Bloquear Usuário/Desbloquear Usuário' do menu usuários`,
    ],
  },
  visualizarUsuarioDesabilitado: {
    name: "Visualizar listagem de usuário desabilitados",
    type: "usuario",
    description: [
      `Libera a visualização da lista de usuários desabilitados no menu de usuários`,
    ],
  },
  podeAnalisarRelatorio: {
    name: "Analisar Relatório --> Pode analisar relatórios",
    type: "menu",
    description: [
      `Libera a visualização do menu 'Analisar Relatórios'`,
      `Libera a possibilidade de visualizar o filtro por Grupo de Solução do menu 'Analisar Relatórios'`,
      `Libera a possibilidade de visualizar o filtro por Responsável do menu 'Analisar Relatórios'`,
      `Libera a possibilidade de visualizar o motivo da rejeição caso o status do relatorio seja igual a reprovado do menu 'Analisar Relatórios'`,
      `Libera a possibilidade de excluir um relatório do menu 'Analisar Relatórios'`,
      `Libera a possibilidade de analisar um relatório ao clicar sobre ele do menu 'Analisar Relatórios'`,
      `Libera a possibilidade de finalziar uma solução do menu 'Analisar Relatórios'`,
      `Libera a possibilidade de visualizar todos os relatórios do menu 'Analisar Relatórios'`,
      `Libera a possibilidade de Aprovar ou Rejeitar um relatório do menu 'Analisar Relatórios'`,
      `Libera a possibilidade de visualizar todos os relatórios dentro da aba 'Relatórios' no município`,
    ],
  },
  podeAnalisarRelatorioAdmin: {
    name: "Analisar Relatório Admin --> Pode analisar relatórios admin",
    type: "menu",
    description: [
      `Libera a visualização do menu 'Analisar/Meus Relatórios Administrativos'`,
      `Libera a possibilidade de visualizar o filtro por Responsável do menu 'Analisar Relatórios Adminsitrativos'`,
      `Libera a possibilidade de excluir um relatório admin. do menu 'Analisar Relatórios Adminsitrativos'`,
      `Libera a possibilidade de avaliar um relatório admin. do menu 'Analisar Relatórios Adminsitrativos'`,
      `Libera a possibilidade de visualizar todos os relatórios admin. do menu 'Analisar Relatórios Adminsitrativos'`,
    ],
  },
  municipiosNaoVigentesRespondemPerguntasNacionais: {
    name: "Municípios não vigentes respondem só perguntas nacionais?",
    type: "sistema",
    description: [
      `Filtra as perguntas para somente nacionais na tela de acompanhamento e diagnóstico`,
    ],
  },
  podeSelecionarMaisDeUmUsuarioSolucao: {
    name: "Solução --> Pode selecionar mais de um responsável por solução",
    type: "termoReferencia",
    description: [
      `Libera a possibilidade de adicionar mais de um responsável na edição/criação de soluções na aba de "Termos de Referência -> Soluções" do município`,
    ],
  },
  visualizaTarefasExecutadas: {
    name: "Visualizar tarefas já executadas",
    type: "calendario",
    description: [
      `Libera a possibilidade de visualizar tarefas já executadas nas opções de tarefas de criação/edição de um evento no calendário do município`,
    ],
  },
  podeCriarTarefaNoCalendario: {
    name: "Criar tarefa",
    type: "calendario",
    description: [
      `Libera a possibilidade de criar tarefas na criação/edição de um evento no calendário do município`,
    ],
  },
  verParcialAcaoFinalizada: {
    name: "Editar Encontro --> Visualizar Parcial e Ação Finalizada",
    type: "calendario",
    description: [
      `Libera a possibilidade de visualizar e editar a opção de 'Parcial' ou 'Ação Finalizada' na criação/edição do evento no calendário do município`,
      `Libera a possibilidade de visualizar o "Tipo de Encontro/Agenda" na criação de um relátorio no município`,
      `Libera a possibilidade de visualizar a opção de "Apenas relatórios de Ações finalizadas" dentro do relatório global`,
    ],
  },
  verMeusRelatorios: {
    name: "Meus Relatórios",
    type: "menu",
    description: [
      `Libera o menu 'Meus Relatórios', porém é necessário a liberação da permissão "Analisar Relatorios" para funcionar`,
    ],
  },
  respondePerguntaEixoMunicipio: {
    name: "Editar Município --> Responde pergunta sobre eixos escolhidos",
    type: "cidade",
    description: [
      `Libera a visualização da pergunta 'Já realiza ações do portfólio do eixo (local ou
                      nacional)?' dentro da edição do município`,
    ],
  },
  verEvolucaoMunicipio: {
    name: "Visualiza Evolução do Município",
    type: "cidade",
    description: [
      `Libera a visualização da "EVOLUÇÃO DO MUNICÍPIO" e seus gráficos`,
    ],
  },
  visualizaRelatorioFinal: {
    name: "Relatório Final",
    type: "cidade",
    description: [
      `Libera a visualização do botão "Relatório Final" dentro do município`,
    ],
  },
  podeTrocarLinkRelFim: {
    name: "Relatório Final --> Editar Link Cliente Oculto",
    type: "cidade",
    description: [
      `Libera a possibilidade de trocar o link do cliente oculto no relatório final`,
    ],
  },
  diagnosticoSelo: {
    name: "Diagnostico do Selo",
    type: "cidade",
    isButton: true,
    description: [
      `Libera a possibilidade de visualizar o mini dash de evidências e possibilidade de visualizar a fase do diagnóstico do selo`,
    ],
  },
  verStatusDiagnosticoSelo: {
    name: "Ver status da fase do diagnóstico",
    type: "cidade",
    description: [
      `Libera a possibilidade de visualizar a fase do diagnóstico do selo, necessário a liberação da permissão do 'Diagnostico do Selo'`,
    ],
  },
  exibirFiltro: {
    name: "Mostrar ou esconder o filtro",
    type: "listaMunicipio",
    description: [
      `Libera a possibilidade de visualizar o filtro da tela de listagem de município`,
    ],
  },
  downloadDiagnostico: {
    name: "Diagnóstico Selo  --> Download PDF",
    type: "cidade",
    description: [
      `Libera a possibilidade de visualizar o botão 'Download Diagnóstico' do diagnóstico do selo`,
    ],
  },
  verDashboardEvidencia: {
    name: "Mini Dashboard Evidências",
    type: "cidade",
    description: [
      `Libera a possibilidade de visualizar o mini dashboard de evidências do selo no município`,
    ],
  },
  relatorioGeral: {
    name: "Relatório Geral",
    type: "dashboard",
    isButton: true,
    description: [`Libera o botão para o relatório geral no menu 'Dashboard'`],
  },
  verPontosObtidos: {
    name: "Ver Pontos Obtidos",
    type: "cidade",
    description: [
      `Libera a visualização de 'Pontos Obtidos' no mini dash de evidências`,
    ],
  },
  incluirObsevacoes: {
    name: "Incluir Observações no relatório geral",
    type: "dashboard",
    description: [`Libera a opção de 'Incluir Observações' no relatório geral`],
  },
  exibirSecretaria: {
    name: "Editar Município --> Exibir secretaria do municipio",
    type: "cidade",
    description: [
      `Libera a possibilidade de criar secretarias na edição do município`,
      `Possibilita visualizar a opção de escolher secretarias para uma solução`,
    ],
  },
  exibirPjAtendida: {
    name: "Visualizar Pessoas Físicas Atendidas",
    type: "relatorio",
    description: [
      `Libera o campo 'Empresas Atendida' no cadastro/edição na aba 'Relatório' do município`,
    ],
  },
  exibirPfAtendida: {
    name: "Visualizar Empresas Atendidas",
    type: "relatorio",
    description: [
      `Libera o campo 'Pessoas Físicas Atendidas' no cadastro/edição na aba 'Relatório' do município`,
    ],
  },
  editaHorasUtilizadas: {
    name: "Editar horas utilizadas",
    type: "relatorio",
    description: [
      `Libera a edição do campo 'Horas Utilizadas' no cadastro/edição na aba 'Relatório' do município`,
    ],
  },
  verCustoPreco: {
    name: "Ver opção de custo e preço",
    type: "solucoes",
    description: [
      `Libera o campo 'Custo' e 'Preço' no cadastro/edição de uma solução em 'Termos de Referências - > Soluções'`,
      `Libera o campo 'Custo' e 'Preço' no cadastro/edição de uma solução no menu 'Projetos e Soluções -> Soluções`,
    ],
  },
  verSomenteRegional: {
    name: "Editar Município --> Ver somente regional",
    type: "cidade",
    description: [
      `Transforma a visualização da edição do município para somente 'Nome do município' e 'UR'`,
    ],
  },
  exibeContrato: {
    name: "Soluções --> Exibir campo Contrato ao criar/editar",
    type: "termoReferencia",
    description: [
      `Libera o campo 'Contrato' no cadastro/ediçãode uma solução na aba 'Termos de Referência -> Soluções' do município`,
    ],
  },
  exibeComunicacaoInterna: {
    name: "Soluções --> Exibir campo Comunicação Interna ao criar/editar",
    type: "termoReferencia",
    description: [
      `Libera o campo 'Comunicação Interna (CI)' no cadastro/ediçãode uma solução na aba 'Termos de Referência -> Soluções' do município`,
    ],
  },
  verTipoSolucao: {
    name: "Soluções --> Exibir campo Tipo de solução.",
    type: "termoReferencia",
    description: [
      `Libera a opção de visualização e edição do campo 'Tipo de solução' na aba 'Termos de Referência -> Soluções' do município`,
      `Libera a opção de visualização e edição do campo 'Tipo de solução' no menu 'Projetos e Soluções -> Soluções'`,
    ],
  },
  editarTipoSolucao: {
    name: "Tipo de Solução",
    type: "menu",
    description: [`Libera o menu 'Tipo de Solução'`],
  },
  verClienteOculto: {
    name: "Ver Cliente Oculto",
    type: "cidade",
    description: [
      `Libera a possibilidade de visualização da aba 'Cliente Oculto' no município`,
    ],
  },
  reabrirCliente: {
    name: "Cliente Oculto --> Reabrir Cliente Oculto",
    type: "cidade",
    isButton: true,
    description: [
      `Libera a visualização do botão 'Reabrir Cliente Oculto' na aba 'Cliente Oculto' no município`,
    ],
  },
  podeFinalizarClienteOculto: {
    name: "Cliente Oculto --> Pode Finalizar Cliente Oculto",
    type: "cidade",
    description: [
      `Libera a visualização do botão 'Finalizar' na aba 'Cliente Oculto' no município`,
    ],
  },
  podeExcluirEncontro: {
    name: "Encontros --> Pode Excluir Encontros",
    type: "menu",
    description: [
      `Libera a possibilidade de excluir encontros no menu 'Encontros'`,
    ],
  },
  podeExcluirRelatorio: {
    name: "Meus Relatórios --> Pode Excluir Relatórios",
    type: "menu",
    description: [
      `Libera a possibilidade de excluir relatórios no menu 'Analisar/Meus Relatórios'`,
    ],
  },
  visualizaTodosEncontros: {
    name: "Encontros --> Pode Visualizar todos os encontros",
    type: "menu",
    description: [
      `Libera a visualização de todos os encontros dentro do Menu -> Encontros`,
    ],
  },
  verMenuCategorias: {
    name: "Categorias",
    type: "menu",
    description: [`Libera a visualização do menu Categorias`],
  },
  verMenuInstituicao: {
    name: "Instituição",
    type: "menu",
    description: [`Libera a visualização do menu Instituição`],
  },
  permiteEditarInstituicao: {
    name: "Instituição --> Editar",
    type: "menu",
    isButton: true,
    description: [`Libera a edição no menu Instituição`],
  },
  permiteDeletarInstituicao: {
    name: "Instituição --> Deletar",
    type: "menu",
    isButton: true,
    description: [`Libera a deleção no menu Instituição`],
  },
  verTodasInstituicao: {
    name: "Instituição --> Ver todas as instituições",
    type: "menu",
    description: [
      `Libera a possibilidade de ver todas as instituições no menu Instituição, caso contrário só poderá ver instituições de municípios que o usuário possua acesso`,
    ],
  },
  permiteAddMunicipiosInstituicao: {
    name: "Instituição --> Visualizar campo municípios na instituição",
    type: "menu",
    description: [`Libera o campos município na instituição`],
  },
  verDataContratoSolucao: {
    name: "Soluções --> Libera campos Inicio e Fim do contrato",
    type: "termoReferencia",
    description: [
      `Libera o campo Início e Fim do contrato dentro da aba de soluções em termo de referência`,
    ],
  },
  verStatusSolucao: {
    name: "Soluções --> Libera campo status contrato",
    type: "termoReferencia",
    description: [
      `Libera o campo Status dentro da aba de soluções em termo de referência`,
    ],
  },
  verPortifolioSolucao: {
    name: "Soluções --> Libera campo Portifólio",
    type: "termoReferencia",
    description: [
      `Libera o campo Portifólio dentro da aba de soluções em termo de referência`,
    ],
  },
  verCampoInstituicaoMembro: {
    name: "Membros --> Ver campo Instituição",
    type: "cidade",
    description: [`Libera a combo Instituição dentro de membros`],
  },
  carregaMembrosGrupos: {
    name: "Carregar combo de membros automática",
    type: "calendario",
    description: [`Carregar combo de membros automática`],
  },
  menuGestaoTerritorios: {
    name: "Liberar menu Gestão de Territórios",
    type: "menu",
    description: [`Liberar menu Gestão de Territórios`],
  },
  gerarEditarProposta: {
    name: "Proposta --> Gerar nova proposta e editar propostas",
    type: "city",
    description: [`Gerar e editar uma proposta`],
  },
  podeExcluirProposta: {
    name: "Proposta --> Pode excluir proposta",
    type: "city",
    description: [`Excluir uma proposta`],
  },
  reverterProposta: {
    name: "Proposta --> Pode revertar o status proposta",
    type: "city",
    description: [`Pode revertar o status proposta`],
  },
  verProjetoPrateleira: {
    name: "Projetos e Solução --> Ver aba projeto",
    type: "menu",
    description: [`Ver a aba projeto dentro do menu de projetos e solução`],
  },
  verTodosMembrosMunicipio: {
    name: "--> Grupo --> Membros --> Editar/Cadastrar ver todos os membros",
    type: "cidade",
    description: [
      `Ver todos os membros de todos os municipios na hora de inserir um membro`,
    ],
  },
  tarefaRealizada: {
    name: "Pode Gerar Tarefa Recorrente",
    type: "calendario",
    description: [`Pode gerar uma tarefa recorrente`],
  },
  naoVerClienteOcultoOuro: {
    name: "Não ver Cliente Oculto em cidades Ouro",
    type: "cidade",
    description: [
      `Libera a visualização da aba de cliente oculto somente para cidades que não sejam ouro`,
    ],
  },
  verMenuProposta: {
    name: " Visualizar proposta ",
    type: "cidade",
    description: [`Libera a aba de proposta na cidade`],
  },

  editarMunicipioVerAtividadeEconomica: {
    name: "Editar Município --> Visualizar Bloco de Atividades Econômicas",
    type: "cidade",
    description: [`Visualizar Atividades Econômicas na edição do município`],
  },

  editarMunicipioVerAD: {
    name: "Editar Município --> Visualizar campo Agente de desenvolvimento (AD)",
    type: "cidade",
    description: [
      `Visualizar campo Agente de desenvolvimento (AD) na edição do município`,
    ],
  },
  editarMunicipioVerPrefeito: {
    name: "Editar Município --> Visualizar Bloco de edição de Prefeito ",
    type: "cidade",
    description: [
      `Libera os campos abaixo da edição do município:`,
      `Prefeito`,
      `Partido`,
    ],
  },
  editarMunicipioVerDadosSocioeconomicos: {
    name: "Editar Município --> Visualizar Bloco de Dados Socioeconômicos",
    type: "cidade",
    description: [
      `Libera os campos abaixo da edição do município:`,
      `População`,
      `Orçamento`,
      `IDH`,
      `PIB`,
      `Densidade Demográfica`,
      `Renda média da população`,
      `Receita`,
      `Despesa`,
      `Número de Empresas`,
      `ME e EPP(N°)`,
      `MEI (N°)`,
      `Mei/Total (%)`,
      `IGM`,
      `Link Google Maps`,
      `Número do Contrato`,
    ],
  },
  editarMunicipioVerEixos: {
    name: "Editar Município --> Visualizar campo Eixo",
    type: "cidade",
    description: [`Visualizar campo Eixo na edição do município`],
  },

  verFaixaIdMunicipio: {
    name: "Editar Município --> Visualizar campo faixa",
    type: "cidade",
    description: [`Visualizar campo Faixa na edição do município`],
  },

  verMenuFaixas: {
    name: "Faixa",
    type: "menu",
    description: [`Visualizar o menu faixa`],
  },

  verBotaoPropostaIniciarExecucao: {
    name: "Proposta --> Pode Iniciar Execução",
    type: "city",
    isButton: true,
    description: [`Libera o botão de Iniciar Execução da proposta`],
  },
};

const headerTypes = {
  calendario: "Municipio --> Cidade --> Calendário -->",
  cidade: "Municipio --> Cidade -->",
  dashboard: "Menu --> Dashboard Admin. -->",
  evidencia: "Municipio --> Cidade --> Evidência -->",
  grupo: "Municipio -- > Cidade-- > Grupos -->",
  menu: "Menu -->",
  relatorio: "Municipio -- > Cidade --> Relatório -->",
  relatorioAdmin: "Municipio -- > Cidade --> Relatório Admin.-->",
  termoReferencia: "Municipio -- > Cidade --> Termo Referen.-->",
  sistema: "Sistema -->",
  usuario: "Usuário -->",
  listaMunicipio: "Lista de Municípios -->",
  solucoes: "Soluções -->",
};

export const initialConfig = {
  acompanhamentos: false,
  agenteTerritorial: false,
  analisarAprovadas: false,
  analisarEvidenciadas: false,
  analisarRejeitadas: false,
  analisarRelatorios: false,
  analisarRelatoriosAdministrativos: false,
  andamento: false,
  cadastroEmLote: false,
  calendario: false,
  configuracao: false,
  dashboardAdministrativo: false,
  editarMunicipio: false,
  eixos: false,
  encontros: false,
  enviarAprovadas: false,
  enviarEvidenciadas: false,
  enviarRejeitadas: false,
  enviarRespondidas: false,
  eventos: false,
  evidencias: false,
  finalizarAcompanhamento: false,
  grupo: false,
  grupos: false,
  medalhas: false,
  meusProcessosPagamentos: false,
  novoAcompanhamento: false,
  novoEvento: false,
  novoGrupo: false,
  novoRelatorio: false,
  novoRelatorioAdministrativo: false,
  pacotes: false,
  perguntas: false,
  processosPagamento: false,
  projetoseSolucoes: false,
  realizarDiagnostico: false,
  relatorioAdministrativo: false,
  relatorioGlobal: false,
  relatorioMensal: false,
  relatorios: false,
  resumoMunicipio: false,
  sala: false,
  salaEmpreendedor: false,
  salvarMunicipio: true,
  salvarMunicipioVigente: false,
  temas: false,
  termoReferencia: false,
  unidadesRegionais: false,
  usuarios: false,
  visualizarAprovadas: false,
  visualizarEvidenciadas: false,
  visualizarLogo: true,
  visualizarPontosMedalha: true,
  visualizarRejeitadas: false,
  desabilitarUsuario: false,
  visualizarUsuarioDesabilitado: false,
  podeAnalisarRelatorio: false,
  podeAnalisarRelatorioAdmin: false,
  municipiosNaoVigentesRespondemPerguntasNacionais: false,
  podeSelecionarMaisDeUmUsuarioSolucao: false,
  visualizaTarefasExecutadas: false,
  podeCriarTarefaNoCalendario: false,
  visualizaEixosIds: "[]",
  verMeusRelatorios: true,
  verParcialAcaoFinalizada: false,
  respondePerguntaEixoMunicipio: false,
  verEvolucaoMunicipio: true,
  visualizaRelatorioFinal: false,
  podeTrocarLinkRelFim: false,
  diagnosticoSelo: false,
  verStatusDiagnosticoSelo: false,
  exibirFiltro: true,
  downloadDiagnostico: false,
  verDashboardEvidencia: false,
  relatorioGeral: false,
  verPontosObtidos: false,
  incluirObsevacoes: false,
  exibirSecretaria: false,
  exibirPjAtendida: false,
  exibirPfAtendida: false,
  editaHorasUtilizadas: false,
  verCustoPreco: false,
  verSomenteRegional: false,
  exibeContrato: false,
  exibeComunicacaoInterna: false,
  verTipoSolucao: false,
  editarTipoSolucao: false,
  verClienteOculto: false,
  reabrirCliente: false,
  podeFinalizarClienteOculto: false,
  podeExcluirEncontro: false,
  podeExcluirRelatorio: false,
  visualizaTodosEncontros: false,
  verMenuCategorias: false,
  verMenuInstituicao: false,
  permiteEditarInstituicao: false,
  permiteDeletarInstituicao: false,
  verTodasInstituicao: false,
  permiteAddMunicipiosInstituicao: false,
  verDataContratoSolucao: false,
  verStatusSolucao: false,
  verPortifolioSolucao: false,
  verCampoInstituicaoMembro: false,
  carregaMembrosGrupos: true,
  menuGestaoTerritorios: false,
  gerarEditarProposta: false,
  podeExcluirProposta: false,
  reverterProposta: false,
  verProjetoPrateleira: false,
  verTodosMembrosMunicipio: false,
  tarefaRealizada: false,
  naoVerClienteOcultoOuro: true,
  verMenuProposta: false,
  editarMunicipioVerAtividadeEconomica: false,
  editarMunicipioVerAD: false,
  editarMunicipioVerPrefeito: false,
  editarMunicipioVerDadosSocioeconomicos: false,
  editarMunicipioVerEixos: false,
  verMenuFaixas: false,
  verFaixaIdMunicipio: false,
  verBotaoPropostaIniciarExecucao: false,
};
